import {HTTP} from '@/CallAPI'
export default {
  getListGroupDocument (page = 1, per_page = '', status = '') {
    return HTTP.get('group-documents', {
      params: {
        page,
        per_page,
        status
      }
    })
  },

  createGroupDocument (GroupDocument) {
    return HTTP.post('group-documents', GroupDocument)
  },

  showGroupDocument (GroupDocument) {
    return HTTP.get('group-documents/' + GroupDocument.id)
  },

  updateGroupDocument (GroupDocument) {
    return HTTP.put('group-documents/' + GroupDocument.id, GroupDocument)
  },

  destroyGroupDocument (GroupDocument) {
    return HTTP.delete('group-documents/' + GroupDocument.id)
  },

  approvalGroupDocument (GroupDocument) {
    return HTTP.post('group-documents/' + GroupDocument.id + '/approval')
  },

  rejectGroupDocument (GroupDocument) {
    return HTTP.post('group-documents/' + GroupDocument.id + '/rejection')
  }
}



// WEBPACK FOOTER //
// ./src/service/group-document.js